import axios from 'axios';
import serialize from 'json-form-data';
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = '/index.php';

export default {
    namespaced: true,

    state: {
        tableColumns: [],
        userTableColumns: [],
        filials: [],
        totalItemsCount: 0,
        totalPages: 1,
        filters: [],
        calculationSheetTransactions: [],
        calculationSheetColumns: [],
        calculationSheetUserColumns: [],
        calculationSheetTotal: {},
        transactionTypesList: [],
        clickedRecord: null,
        clickedDetailedRecord: null,
        currentPage: 1
    },

    mutations: {
        setTableColumns(state, tableColumns) {
            state.tableColumns = tableColumns;
        },
        setUserTableColumns(state, userTableColumns) {
            state.userTableColumns = userTableColumns;
        },
        setTotalItemsCount(state, amount) {
            state.totalItemsCount = amount;
        },
        setTotalPages(state, amount) {
            state.totalPages = amount;
        },
        setFilials(state, filials) {
            state.filials = filials;
        },
        setFilters(state, filters) {
            state.filters = filters;
        },
        setCalculationSheetTransactions(state, transactions) {
            state.calculationSheetTransactions = transactions;
        },
        setCalculationSheetTotal(state, total) {
            state.calculationSheetTotal = total;
        },
        setCalculationSheetColumns(state, columns) {
            state.calculationSheetColumns = columns;
        },
        setCalculationSheetUserColumns(state, columns) {
            state.calculationSheetUserColumns = columns;
        },
        setTransactionTypesList(state, transactionTypesList) {
            state.transactionTypesList = transactionTypesList;
        },
        setClickedRecord(state, clickedRecord) {
            state.clickedRecord = clickedRecord;
        },
        setClickedDetailedRecord(state, clickedDetailedRecord) {
            state.clickedDetailedRecord = clickedDetailedRecord;
        },
        setCurrentPage(state, page) {
            state.currentPage = page;
        }
    },

    actions: {
        async getFilials({commit, rootState}) {
            const token = rootState.authToken;
            const {data} = await axios.get(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/filials`, token));

            commit('setFilials', data);

            return data;
        },
        async getTableColumns({commit, rootState}) {
            const token = rootState.authToken;
            const {data} = await axios.get(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/columns`, token));

            commit('setTableColumns', data.columns);
        },
        async getUserTableColumns({commit, rootState}) {
            const token = rootState.authToken;
            const {userId} = rootState;
            const url = addAuthKey(`${api_url}?r=api/calculation-sheet/user-columns&user_id=${userId}`, token);

            const {data} = await axios.get(url);
            commit('setUserTableColumns', data.columns);
        },
        async saveUserTableColumns({commit, rootState}, columns) {
            const token = rootState.authToken;
            const {userId} = rootState;
            const formData = new FormData();

            formData.append('columns', JSON.stringify(columns));
            formData.append('user_id', userId);

            const url = addAuthKey(`${api_url}?r=api/calculation-sheet/save-user-columns`, token);

            await axios.post(url, formData);
            commit('setUserTableColumns', columns);
        },
        async getCalculationSheets({commit, rootState}, params) {
            const token = rootState.authToken;
            const {sort, page, filters} = params;

            const form_data = new FormData();

            if (filters && filters.columnFilters) {
                for (let filterName in filters.columnFilters) {
                    form_data.append(`params[${filterName}_search_type]`,
                        filters.columnFilters[filterName].searchType);

                    if (filters.columnFilters[filterName].type === 'date' &&
                        filters.columnFilters[filterName].searchType ===
                        'range') {
                        form_data.append(`params[${filterName}_value]`,
                            filters.columnFilters[filterName].value[0]);
                        form_data.append(`params[${filterName}_value_end]`,
                            filters.columnFilters[filterName].value[1]);
                    } else if (filters.columnFilters[filterName].type ===
                        'number' &&
                        filters.columnFilters[filterName].searchType === '4') {
                        form_data.append(`params[${filterName}_value]`,
                            filters.columnFilters[filterName].value.start);
                        form_data.append(`params[${filterName}_value_end]`,
                            filters.columnFilters[filterName].value.end);
                    } else {
                        form_data.append(`params[${filterName}_value]`,
                            filters.columnFilters[filterName].value);
                    }
                }
            }

            if (filters && filters.globalFilters) {
                for (let filterName in filters.globalFilters) {
                    form_data.append(`params[${filterName}_search_type]`,
                        filters.globalFilters[filterName].searchType);

                    if (filters.globalFilters[filterName].type === 'date' &&
                        filters.globalFilters[filterName].searchType ===
                        'range') {
                        form_data.append(`params[${filterName}_value]`,
                            filters.globalFilters[filterName].value[0]);
                        form_data.append(`params[${filterName}_value_end]`,
                            filters.globalFilters[filterName].value[1]);
                    } else if (filters.globalFilters[filterName].type ===
                        'number' &&
                        filters.globalFilters[filterName].searchType === '4') {
                        form_data.append(`params[${filterName}_value]`,
                            filters.globalFilters[filterName].value.start);
                        form_data.append(`params[${filterName}_value_end]`,
                            filters.globalFilters[filterName].value.end);
                    } else {
                        form_data.append(`params[${filterName}_value]`,
                            filters.globalFilters[filterName].value);
                    }
                }
            }

            if (params.is_deleted === 0 || params.is_deleted ===
                1) form_data.append('params[is_deleted]', params.is_deleted);

            if (sort) form_data.append('params[sort]', sort);

            const url = addAuthKey(`${api_url}/?r=api/calculation-sheet/index${page > -1 ?
                '&page=' + page :
                ''}`, token);

            const {data, headers} = await axios.post(url, form_data);

            commit('setTotalItemsCount', +headers['x-pagination-total-count']);
            commit('setTotalPages', +headers['x-pagination-page-count']);

            return data;
        },
        async removeCalculationSheet({rootState}, {id}) {
            const token = rootState.authToken;
            const {data} = await axios.get(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/delete&id=${id}`, token));

            return data;
        },
        async checkIntersection({commit, rootState}, params) {
            const token = rootState.authToken;
            const formData = new FormData();
            const {filial, period} = params;

            formData.append('period', period);
            formData.append('filial', filial);

            let data;

            await axios.post(
                addAuthKey(`${api_url}?r=api/calculation-sheet/check-intersection`, token),
                formData).then((res) => {
                data = res.data;
            });

            return data;
        },
        async createCalculationSheet({commit, rootState}, params) {
            const token = rootState.authToken;
            const formData = new FormData();
            const {filial, period} = params;

            formData.append('period', period);
            formData.append('filial', filial);

            let data;

            await axios.post(
                addAuthKey(`${api_url}?r=api/calculation-sheet/create`, token),
                formData).then((res) => {
                data = res.data;
            });

            return data;
        },
        async getFilters({commit, rootState}, id) {
            const token = rootState.authToken;
            const {data} = await axios.get(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/filters&id=${id}`, token));

            commit('setFilters', data);
        },
        async getCalculationSheetTransactions(
            {commit, rootState}, {id, filters, sortingField, requestFilters}) {
            const token = rootState.authToken;
            const form_data = new FormData();

            for (let filter in filters) {
                if (filters[filter]) {
                    let value = filters[filter].map(item => (item.value)).
                        join(',');
                    form_data.append(`params[${filter}_search_type]`, 1);
                    form_data.append(`params[${filter}_value]`, value);
                }
            }

            if(sortingField) {
                form_data.append(`params[sort]`, sortingField);
            }

            if(!!requestFilters && requestFilters.length > 0) {
                requestFilters.forEach((filter) => {
                    let value = filter.value;
                    if (Array.isArray(value)) {
                        value = value.map(item => item.id).join(',');
                    }
                    if(filter.filterName === 'worker') {
                        form_data.append(`params[worker_name_search_type]`, filter.type);
                        form_data.append(`params[worker_name_value]`, value);
                    } else if(filter.filterName === 'crm_id') {
                        form_data.append(`params[iiko_user_search_type]`, filter.type);
                        form_data.append(`params[iiko_user_code_value]`, value);
                    } else {
                        form_data.append(`params[${filter.filterName}_search_type]`, filter.type);
                        form_data.append(`params[${filter.filterName}_value]`, value);
                    }
                });
            }

            const {data} = await axios.post(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/sheet-transactions&id=${id}`, token),
                form_data);

            commit('setCalculationSheetTransactions', data);
        },
        async getCalculationSheetTotal({commit, rootState}, {id, filters}) {
            const token = rootState.authToken;
            const form_data = new FormData();

            for (let filter in filters) {
                if (filters[filter]) {
                    let value = filters[filter].map(item => (item.value)).
                        join(',');
                    form_data.append(`params[${filter}_search_type]`, 1);
                    form_data.append(`params[${filter}_value]`, value);
                }
            }

            const {data} = await axios.post(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/sheet-transactions-summary&id=${id}`, token),
                form_data);

            commit('setCalculationSheetTotal', {isTotal: true, ...data});
        },
        async getCalculationSheetColumns({commit, rootState}) {
            const token = rootState.authToken;
            const {data} = await axios.get(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/sheet-columns`, token));

            commit('setCalculationSheetColumns', data);
        },
        async getCalculationSheetUserColumns({commit, rootState}) {
            const token = rootState.authToken;
            const {data} = await axios.get(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/sheet-user-columns`, token));

            commit('setCalculationSheetUserColumns', data.columns);
        },
        async saveCalculationSheetUserColumns(
            {commit, rootState}, userColumns) {
            const token = rootState.authToken;
            const formData = new FormData();
            const {userId} = rootState;

            formData.append('columns', JSON.stringify(userColumns));
            formData.append('user_id', userId);

            const url = addAuthKey(`${api_url}?r=api/calculation-sheet/save-user-sheet-columns`, token);

            await axios.post(url, formData);
        },
        async getTransactionTypesList({commit, rootState}) {
            const token = rootState.authToken;
            const url = addAuthKey(`${api_url}/?r=api/transaction-type/index`, token);
            const {data} = await axios.get(url);

            commit('setTransactionTypesList', data);
        },
        async getTypeTransactionColumns({commit, rootState}, transaction_type) {
            const token = rootState.authToken;
            const {data} = await axios.get(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/type-transaction-columns&transaction_type=${transaction_type}`, token));

            return data;
        },
        async getTypeTransactions({commit, rootState}, params) {
            const {sort, page, filters} = params;
            const token = rootState.authToken;

            const form_data = new FormData();

            if (filters && filters.columnFilters) {
                for (let filterName in filters.columnFilters) {
                    // todo HRMS-3708 т.к не приходят новые проводки
                    if (filterName === 'post') {
                        form_data.append(`params[${filterName}_search_type]`, 0);
                    } else {
                        form_data.append(`params[${filterName}_search_type]`,
                            filters.columnFilters[filterName].searchType);
                    }

                    if (filters.columnFilters[filterName].type === 'date' &&
                        filters.columnFilters[filterName].searchType ===
                        'range') {
                        form_data.append(`params[${filterName}_value]`,
                            filters.columnFilters[filterName].value[0]);
                        form_data.append(`params[${filterName}_value_end]`,
                            filters.columnFilters[filterName].value[1]);
                    } else if (filters.columnFilters[filterName].type ===
                        'number' &&
                        filters.columnFilters[filterName].searchType === '4') {
                        form_data.append(`params[${filterName}_value]`,
                            filters.columnFilters[filterName].value.start);
                        form_data.append(`params[${filterName}_value_end]`,
                            filters.columnFilters[filterName].value.end);
                    } else {
                        form_data.append(`params[${filterName}_value]`,
                            filters.columnFilters[filterName].value);
                    }
                }
            }

            form_data.append('params[sort]', sort);

            const url = addAuthKey(`${api_url}/?r=api/calculation-sheet/type-transactions&worker_id=${params.worker_id}&is_delete=0`, token);

            const {data} = await axios.post(url, form_data);

            return data;
        },
        async getVacationOrSickById({commit, rootState}, id) {
            const token = rootState.authToken;
            const {data} = await axios.get(
                addAuthKey(`${api_url}/?r=api/vacations/view&id=${id}`, token));

            return data;
        },
        async createTransactionForType({commit, state, rootState}, params) {
            const token = rootState.authToken;

            const fd = serialize(params);

            await axios.post(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/create-transaction-for-type`, token),
                fd);
        },
        async createMassTransaction({commit, state, rootState}, transactions) {
            const token = rootState.authToken;

            await axios.post(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/create-mass-transaction`, token),
                JSON.stringify(transactions), {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
        },
        async getPayedLeft({commit, state, rootState}, params) {
            const token = rootState.authToken;
            const {worker_id, filial_id, post_code, date_to, sheet_id} = params;

            const {data} = await axios.post(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/payed-left&worker_id=${worker_id}&filial_id=${filial_id}&post_code=${post_code}&sheet_id=${sheet_id}&date_to=${date_to}`, token));

            return data;
        },
        async fetchCompaniesForTransactions({commit, state, rootState}, id) {
            const token = rootState.authToken;

            const {data} = await axios.get(
                addAuthKey(
                    `${api_url}?r=api/filial/company&filial_id=${id}`,
                    token));

            return data;
        },
        async getFilialWorkers({commit, state, rootState}, filialIds) {
            const token = rootState.authToken;

            const queryString = filialIds.map((id, index) => `id[${index}]=${id}`).join('&');

            const {data} = await axios.get(
                addAuthKey(
                    `${api_url}?r=api/calculation-sheet/filial-workers-list&${queryString}`,
                    token));

            return data;
        },
        async getAllWorkers({rootState}) {
            const token = rootState.authToken;

            const {data} = await axios.get(
                addAuthKey(
                    `${api_url}?r=api/calculation-sheet/workers-list`, token));

            return data;
        },

        async addWorkersToCalculationSheet({rootState}, params) {
            const token = rootState.authToken;

            const {data} = await axios.post(
                addAuthKey(`${api_url}?r=api/calculation-sheet/add-worker`, token), params);

            return data;
        },
        setCurrentRecord({ commit }, record) {
            commit('setClickedRecord', record);
        },
        setCurrentDetailedRecord({ commit }, record) {
            commit('setClickedDetailedRecord', record);
        },
        setCurrentPage({ commit }, page) {
            commit('setCurrentPage', page);
        },
    },
};